import { render, staticRenderFns } from "./WaterQuality.vue?vue&type=template&id=63505728&scoped=true"
import script from "./WaterQuality.vue?vue&type=script&lang=js"
export * from "./WaterQuality.vue?vue&type=script&lang=js"
import style0 from "./WaterQuality.vue?vue&type=style&index=0&id=63505728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63505728",
  null
  
)

export default component.exports